import { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { mySession } from 'happ-redux/happ-actions/login/loginActions';


const useAuthSession = () => {
    const dispatch = useDispatch();
    const [profile, setProfile] = useState({});
    const [me, setMe] = useState(false);
    const isLogin = useSelector(state => state.login.login);
    const getMeProfile = useSelector(state => state.login.login_profile);

    useEffect(() => {
        dispatch(mySession());
        if (isLogin) {
            setProfile(getMeProfile);
          } else {
            setProfile({
              dni: '',
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              gender: '',
              healthForecast: '',
              birthday: '',
              street: '',
              commune: '',
              region: '',
              company: '',
              branchOffice: '',
            });
          }
    },[isLogin]);
    
    return profile;

}

export default useAuthSession;